var ElementManager = {
	elements: [],
	folderelements: {},
	lastFolder: null,
	firstLoad: true,

	load: function(elems) {
		AppEvent.trigger(ElementManager, "beforeLoad", {});

		if (ElementManager.firstLoad) {
			Tab.setGroup("elements", "+");
			ElementManager.firstLoad = false;
		}

		if (ElementManager.lastFolder != null && ElementManager.lastFolder != player.folder) {
			for(var el in ElementManager.folderelements) {
				ElementManager.remove(ElementManager.folderelements[el]);
			}
			ElementManager.folderelements = {};
		}
		ElementManager.lastFolder = player.folder;
		
		/*
		for(var el in ElementManager.elements) {
			if (ElementManager.folderelements[ElementManager.elements[el].id] == undefined)
				ElementManager.remove(ElementManager.elements[el]);
		}
		*/

		var saved = {};

		for(var el in elems) {
			var c = elems[el];

			saved[c.id] = 1;

			if (ElementManager.folderelements[c.id] != undefined) {
				ElementManager.folderelements[c.id].refresh();
				continue;
			}

			var ec = new UIElement(c.x, c.y, c.type, JSON.parse(c.params), c.id, c.folder_wide, c.place_id);
			ElementManager.elements.push(ec);

			//if (ec.params.$folderelement == "1") ElementManager.folderelements[ec.id] = ec;
			if (ec.folder_wide != "0") ElementManager.folderelements[ec.id] = ec;

			if (player.cms) {
				ec.editor.addUI();
			}

		}

		for(var el in ElementManager.folderelements) {
			if (saved[el] == undefined) {
				ElementManager.remove(ElementManager.folderelements[el]);
				delete ElementManager.folderelements[el];
			}
		}
		
	},

	add: function(uie) {
		ElementManager.elements.push(uie);
	},

	remove: function(el) {
		el.destroy();
		for(var ind in ElementManager.elements) {
			var ce = ElementManager.elements[ind];
			if (ce === el) {
				ElementManager.elements.splice(ind, 1);
				return;
			}
		}
	}

}